import { render, staticRenderFns } from "./enderecoAstec.vue?vue&type=template&id=3492a496"
import script from "./enderecoAstec.vue?vue&type=script&lang=js"
export * from "./enderecoAstec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports